// Admin session helpers — token storage, 30-min inactivity timeout, and
// browser back-button prevention after logout.
//
// - Remember me = true  -> localStorage  (persists across browser restarts)
// - Remember me = false -> sessionStorage (cleared when the tab/browser closes)
//   In both cases, 30 minutes of inactivity signs the user out.

const TOKEN_KEY = "bf_token";
const REMEMBER_KEY = "bf_remember";
const LAST_ACTIVE_KEY = "bf_last_active";

export const INACTIVITY_MS = 30 * 60 * 1000; // 30 minutes

const stores = () => [localStorage, sessionStorage];

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY) || null;
}

export function saveSession(token, rememberMe) {
  clearSession();
  const store = rememberMe ? localStorage : sessionStorage;
  store.setItem(TOKEN_KEY, token);
  store.setItem(REMEMBER_KEY, rememberMe ? "1" : "0");
  store.setItem(LAST_ACTIVE_KEY, String(Date.now()));
}

export function clearSession() {
  stores().forEach((s) => {
    s.removeItem(TOKEN_KEY);
    s.removeItem(REMEMBER_KEY);
    s.removeItem(LAST_ACTIVE_KEY);
  });
}

export function touchActivity() {
  const store = sessionStorage.getItem(TOKEN_KEY) ? sessionStorage : (localStorage.getItem(TOKEN_KEY) ? localStorage : null);
  if (store) store.setItem(LAST_ACTIVE_KEY, String(Date.now()));
}

export function isExpiredByInactivity() {
  const store = sessionStorage.getItem(TOKEN_KEY) ? sessionStorage : (localStorage.getItem(TOKEN_KEY) ? localStorage : null);
  if (!store) return true;
  const last = Number(store.getItem(LAST_ACTIVE_KEY) || 0);
  if (!last) return false;
  return Date.now() - last > INACTIVITY_MS;
}

// Prevents the Back button from restoring the admin dashboard after logout.
// Push a sentinel state and redirect to a safe URL on popstate.
export function blockBackNavigation(redirectTo = "/") {
  try {
    window.history.replaceState({ signedOut: true }, "", redirectTo);
    window.history.pushState({ signedOut: true }, "", redirectTo);
    const handler = () => { window.location.replace(redirectTo); };
    window.addEventListener("popstate", handler, { once: false });
  } catch (_) { /* no-op */ }
}
